var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit02 = function SvgEdit02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2024",
    fillRule: "evenodd",
    d: "M16.293 2.293a3.828 3.828 0 1 1 5.414 5.414l-2.997 2.997-.003.003-.003.003L8.502 20.913l-.05.05c-.245.246-.461.462-.718.631q-.34.224-.727.35c-.293.095-.597.128-.941.166l-.07.008-3.385.376a1 1 0 0 1-1.104-1.104l.376-3.385.008-.07c.038-.344.071-.648.166-.94a3 3 0 0 1 .35-.728c.169-.257.385-.473.63-.718l.05-.05zM14 7.414l-9.5 9.5c-.322.322-.382.388-.425.454a1 1 0 0 0-.116.242c-.024.074-.039.163-.09.616l-.237 2.142 2.142-.238c.453-.05.542-.065.616-.089q.13-.042.242-.117c.066-.043.132-.102.455-.425L16.586 10zm4 1.172L15.414 6l2.293-2.293a1.828 1.828 0 0 1 2.586 2.586z",
    clipRule: "evenodd"
  })));
};
export default SvgEdit02;